/**
 * Cihaz kimliği ve kullanıcının verdiği cihaz adı.
 *
 * Tarayıcı MAC adresi, hostname ya da gerçek yerel IP vermiyor (WebRTC'nin sızdırdığı
 * yerel adres de artık her oturumda değişen bir mDNS takma adı). Giriş kayıtlarında
 * "aynı cihaz mı" sorusunu cevaplayabilmenin tek yolu, ilk girişte üretilip bu tarayıcıda
 * saklanan bir kimlik.
 *
 * Sınırı bilerek kabul ediliyor: tarayıcı verisi silinirse ya da gizli pencere
 * kullanılırsa yeni kimlik üretilir. Yani kimlik CİHAZI DEĞİL, "bu tarayıcı profilini"
 * işaretler — kimlik doğrulamada kullanılmaz, yalnızca denetim kaydını okunur kılar.
 *
 * Kullanıcı bazlı tercihlerin (prefsStore) aksine bunlar SUNUCUYA GİTMEZ: aynı kullanıcı
 * iki ayrı bilgisayardan giriyorsa her birinin kendi adı olmalı.
 */
const ID_KEY = 'octo.device.id';
const NAME_KEY = 'octo.device.name';

/** Depolama erişimi gizli pencerede ya da site verisi kapalıyken patlayabiliyor. */
function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* kalıcılık yoksa kimlik bu oturuma özel kalır */
  }
}

let memoryId: string | null = null;

/**
 * Bu tarayıcının kalıcı kimliği; ilk çağrıda üretilir.
 *
 * Depolama kullanılamıyorsa kimlik yalnızca bellekte tutulur: sayfa yenilenene kadar
 * aynı kalır, sonra değişir. Kayıtta kimliğin olmaması, her seferinde yeni bir kimlik
 * yazılmasından daha az yanıltıcı olurdu; ama o durumda oturum içindeki kayıtlar da
 * birbirine bağlanamazdı.
 */
export function deviceId(): string {
  if (memoryId) return memoryId;
  const stored = read(ID_KEY);
  if (stored) {
    memoryId = stored;
    return stored;
  }
  const created = crypto.randomUUID();
  write(ID_KEY, created);
  memoryId = created;
  return created;
}

/** Kullanıcının Ayarlar'dan verdiği ad; verilmediyse null. */
export function deviceName(): string | null {
  const name = read(NAME_KEY)?.trim();
  return name ? name : null;
}

/** Boş ad kaydı SİLER: kullanıcı adı temizlediğinde kayıtta eski ad kalmamalı. */
export function setDeviceName(name: string) {
  const trimmed = name.trim().slice(0, 60);
  try {
    if (trimmed) localStorage.setItem(NAME_KEY, trimmed);
    else localStorage.removeItem(NAME_KEY);
  } catch {
    /* kalıcılık yoksa ad bu oturumda da tutulamaz */
  }
}

/**
 * Giriş kaydına yazılan cihaz bölümü: "Ad (kimlik)" ya da yalnızca kimlik.
 * Kimlik hep yazılır — ad değiştirilebilir, eşleştirme kimlik üzerinden yapılır.
 */
export function deviceTag(): string {
  const name = deviceName();
  return name ? `${name} (${deviceId()})` : deviceId();
}
